/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_Event_DisapprovedInputs */

const en_error_nav_event_disapproved = /** @type {(inputs: Error_Nav_Event_DisapprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event marked as disapproved.`)
};

const fr_error_nav_event_disapproved = /** @type {(inputs: Error_Nav_Event_DisapprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evenement marque comme desapprouve.`)
};

const de_error_nav_event_disapproved = /** @type {(inputs: Error_Nav_Event_DisapprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Veranstaltung wurde als abgelehnt markiert.`)
};

const it_error_nav_event_disapproved = /** @type {(inputs: Error_Nav_Event_DisapprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento contrassegnato come non approvato.`)
};

const ru_error_nav_event_disapproved = /** @type {(inputs: Error_Nav_Event_DisapprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мероприятие помечено как отклоненное.`)
};

const es_error_nav_event_disapproved = /** @type {(inputs: Error_Nav_Event_DisapprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento marcado como desaprobado.`)
};

const zh_cn2_error_nav_event_disapproved = /** @type {(inputs: Error_Nav_Event_DisapprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活动被标记为不予批准。`)
};

const ja_error_nav_event_disapproved = /** @type {(inputs: Error_Nav_Event_DisapprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントは不承認としてマークされました。`)
};

const hi_error_nav_event_disapproved = /** @type {(inputs: Error_Nav_Event_DisapprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस आयोजन को अस्वीकृत घोषित किया गया है।`)
};

const pt_pt2_error_nav_event_disapproved = /** @type {(inputs: Error_Nav_Event_DisapprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento marcado como reprovado.`)
};

/**
* | output |
* | --- |
* | "Event marked as disapproved." |
*
* @param {Error_Nav_Event_DisapprovedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_event_disapproved = /** @type {((inputs?: Error_Nav_Event_DisapprovedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Event_DisapprovedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_nav_event_disapproved(inputs)
	if (locale === "de") return de_error_nav_event_disapproved(inputs)
	if (locale === "it") return it_error_nav_event_disapproved(inputs)
	if (locale === "ru") return ru_error_nav_event_disapproved(inputs)
	if (locale === "es") return es_error_nav_event_disapproved(inputs)
	if (locale === "zh-CN") return zh_cn2_error_nav_event_disapproved(inputs)
	if (locale === "ja") return ja_error_nav_event_disapproved(inputs)
	if (locale === "hi") return hi_error_nav_event_disapproved(inputs)
	if (locale === "pt-PT") return pt_pt2_error_nav_event_disapproved(inputs)
	return en_error_nav_event_disapproved(inputs)
});